var React = require('react');

function IconInformationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0A8 8 0 0 0 .609 4.939a8 8 0 0 0 1.734 8.718 8 8 0 0 0 8.718 1.734A8 8 0 0 0 16 8a8.01 8.01 0 0 0-2.346-5.654A8.01 8.01 0 0 0 8 0zm0 12.923a.919.919 0 0 1-.853-.57.926.926 0 0 1 .2-1.006.928.928 0 0 1 1.006-.2A.923.923 0 0 1 8 12.923zm.615-3.761v.069a.616.616 0 0 1-1.23 0v-.615A.616.616 0 0 1 8 8a1.54 1.54 0 0 0 1.421-.95 1.54 1.54 0 0 0-.334-1.677A1.54 1.54 0 0 0 7.41 5.04a1.54 1.54 0 0 0-.95 1.421.616.616 0 0 1-1.23 0 2.77 2.77 0 0 1 1.568-2.495 2.77 2.77 0 0 1 2.928.331 2.77 2.77 0 0 1 .973 2.782 2.77 2.77 0 0 1-2.084 2.083z","fill":"currentColor"}));
}

IconInformationInline.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16","fill":"none"};

module.exports = IconInformationInline;

IconInformationInline.default = IconInformationInline;
